import getRetailTokenClient from "@utils/getRetailToken.client";
import type { CustomerStatus } from "@services/customerStatusService";

const apiPath = () =>
  `/api/customer-status`;

/**
 * Client-only: calls internal Next route which proxies to workspace with RetailToken.
 */
export async function fetchCustomerStatusViaNextApi(): Promise<CustomerStatus | null> {
  const retailToken = await getRetailTokenClient();
  try {
    const res = await fetch(apiPath(), {
      method: "GET",
      headers: {
        Accept: "application/json",
        ...(retailToken ? { RetailToken: retailToken } : {}),
      },
      signal: AbortSignal.timeout(10_000),
    });

    if (!res.ok) {
      console.warn("[fetchCustomerStatusViaNextApi] Next API returned non-OK", {
        status: res.status,
        statusText: res.statusText,
      });
      return null;
    }

    const data = (await res.json()) as CustomerStatus;
    console.info("[fetchCustomerStatusViaNextApi] Customer status received");
    return data;
  } catch (error) {
    console.warn("[fetchCustomerStatusViaNextApi] Fetch failed:", error);
    return null;
  }
}
